import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { ApiService } from '../../api.service';
import { FunctionsService } from "../../services/functions.service";
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl, UntypedFormArray, ValidatorFn } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationModel } from './notificationModel';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { EditNotificationComponent } from './edit-notification/edit-notification.component';
import { ConfirmationModalComponent } from 'src/app/generic-components/confirmation-modal/confirmation-modal.component';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { NgxSpinnerService } from "ngx-spinner";
import { AppConstants } from 'src/app/app.constants';
import { PaginationModel } from 'src/app/models/paginationModel';
import { OkModalComponent } from 'src/app/generic-components/ok-modal/ok-modal.component';
import { Router } from '@angular/router';
import { DateAdapter } from '@angular/material/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.css'],
    providers: [NgxSpinnerService]
})

export class NotificationComponent implements OnInit {
    displayedColumns: string[] = ['message', 'userGroup', 'created', 'sentDate', 'status', 'scheduled', 'actions'];
    dataSource = new MatTableDataSource<any>();
    notiDate: any;
    formSubmitted: boolean = false;
    roles = ["User","Admin","SecurityAgent","Supervisor"];
    @ViewChild(MatSort, {static: true}) sort: MatSort;
    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
    language = localStorage.getItem('language')?localStorage.getItem('language'):'en';
    public min: Date = new Date("01/01/" + ((new Date()).getFullYear() - 4).toString());
    currentDate: Date = new Date();
    totalLength = 0;
    active = "Created";
    direction = "DESC";
    pageIndex = 0;
    pageSize = 5;
    filter = "";
    filterDate = "";
    scheduleDate = "";
    scrHeight:any;
    scrWidth:any;
    filterApplied = false;
    customGroups = [];
    groupList = [];
    selectedGroups = [];
    dropdownSettings = {};
    selectedOptions = [];
    scheduleNoti = { option: "0" };
    hours = [];
    approve = false;
    approver = false;
    expired: any;

    filterNotiForm = this.formBuilder.group({
        filterDate: new UntypedFormControl('', Validators.compose([Validators.required]))
    }); 
    
    constructor(
        private apiService: ApiService,
        public functionsService: FunctionsService,
        private notification: NotificationModel,
        private formBuilder: UntypedFormBuilder,
        private modalService: NgbModal,
        private translate: TranslateService,
        private spinner: NgxSpinnerService,
        private pagination: PaginationModel,
        private router: Router,
        public constants: AppConstants,
        private deviceService: DeviceDetectorService,
        private dateAdapter: DateAdapter<Date>
    ) { 
        if(this.router.url==='/'){
            this.router.navigateByUrl('main/activeAlerts');
        }
        this.notiDate = functionsService;
        this.getScreenSize();
        this.hours = this.functionsService.hourDropDown(30);
        this.addNotificationForm = this.formBuilder.group({
            message: new UntypedFormControl('', Validators.compose([Validators.required, Validators.pattern(AppConstants.noLeadingRegEx)])),
            options: new UntypedFormArray([], this.minSelectedCheckboxes(1)),
            schedule: new UntypedFormControl(''),
            scheduleDate: new UntypedFormControl('')
        });   
        this.addCheckboxes();
    }

    showAddNotificationForm: boolean = false;
    addNotificationForm: UntypedFormGroup;
    
    get optionsFormArray() {
        return this.addNotificationForm.controls.options as UntypedFormArray;
    }

    private addCheckboxes() {
        this.constants.sendOptions.forEach((element) => {
            var fControl = (element.id=="pushNotification")?new UntypedFormControl(true):new UntypedFormControl(false);
            this.optionsFormArray.push(fControl)
        });
    }

    async ngOnInit() {
        this.expired = await this.functionsService.isExpired();
        this.pagination.TimeZone = (-1)*(new Date().getTimezoneOffset()/60);
        this.getScreenSize();
        this.functionsService.setTitle('notification.notifications');
        var orgId = await this.functionsService.getOrg();

        this.dateAdapter.setLocale(this.language);  
        
        this.translate.onLangChange.subscribe((event) => {
            if(document.getElementsByClassName("mat-paginator-page-size-label")[0]){
                document.getElementsByClassName("mat-paginator-page-size-label")[0].innerHTML = this.translate.instant("paginator.items_per_page");
            }
            this.language = event.lang;
            this.dateAdapter.setLocale(this.language);  
            this.groupList = [];
            for(var i=0; i<this.roles.length; i++){
                role = this.translate.instant(this.translate.instant(this.roles[i]));
                this.groupList.push({ tagId: this.roles[i]+"#"+orgId, tagName: role });
            }
            this.groupList = this.groupList.concat(this.customGroups);
            this.dropdownSettings = {
                singleSelection: false,
                idField: 'tagId',
                textField: 'tagName',
                searchPlaceholderText: this.translate.instant('general.search'),
                noDataAvailablePlaceholderText: this.translate.instant('general.no_data_avail'), 
                selectAllText: this.translate.instant("general.select_all"),
                unSelectAllText: this.translate.instant("general.unselect_all"),
                itemsShowLimit: 5,
                allowSearchFilter: true
            };
        });

        this.approverCheck();
        this.dataSource.sort = this.sort;
        this.fetchGroups();
        this.fetchNotifications();

        this.dropdownSettings = {
            singleSelection: false,
            idField: 'tagId',
            textField: 'tagName',
            searchPlaceholderText: this.translate.instant('general.search'),
            noDataAvailablePlaceholderText: this.translate.instant('general.no_data_avail'), 
            selectAllText: this.translate.instant("general.select_all"),
            unSelectAllText: this.translate.instant("general.unselect_all"),
            itemsShowLimit: 5,
            allowSearchFilter: true
        };

        var role = "";
        for(var i=0; i<this.roles.length; i++){
            role = this.translate.instant(this.translate.instant(this.roles[i]));
            this.groupList.push({ tagId: this.roles[i]+"#"+orgId, tagName: role });
        }
    }

    toggleShowAddNotificationForm() {
        if(this.showAddNotificationForm){
            document.getElementById("cancel_toggle").hidden = true;
            document.getElementById("add_toggle").hidden = false;
        }else{
            document.getElementById("add_toggle").hidden = true;
            document.getElementById("cancel_toggle").hidden = false;
        }
        this.selectedGroups = [];
        this.addNotificationForm.reset();
        this.optionsFormArray.clear();
        this.addCheckboxes();
        this.showAddNotificationForm = !this.showAddNotificationForm;
        this.scheduleNoti = { option: "0" };
    }

    private approverCheck(){
        this.apiService.isApprover().subscribe(
            data => {
                this.approve = data['approve'];
                this.approver = data['approver'];
            }
        );
    }

    private fetchGroups(){
        this.apiService.getGroups().subscribe(resp => {
            let jsonString = JSON.stringify(resp);
            let jsonObject = JSON.parse(jsonString);
            if(jsonObject){
                for(var i=0; i<jsonObject.length; i++){
                    this.customGroups.push({ tagId: jsonObject[i].id+'&'+jsonObject[i].name, tagName: jsonObject[i].name });
                }
                this.groupList = this.groupList.concat(this.customGroups);
            }
        }, error => {
            this.functionsService.errorHandler(error["status"]);
            this.spinner.hide();
        });
    }

    private fetchNotifications() {
        this.spinner.show();
        this.pagination.Page = this.pageIndex;
        this.pagination.PageSize = this.pageSize;
        this.pagination.OrderBy = this.active;
        this.pagination.Order = this.direction;
        this.pagination.Filter = this.filter;
        this.pagination.FilterDate = this.filterDate;
        this.apiService.getNotificationsPagination(this.pagination).subscribe(resp => {
            this.dataSource.data = Object.values(resp)[0];
            this.totalLength = parseInt(Object.keys(resp)[0]);
            const paginatorLabel = document.getElementsByClassName("mat-paginator-page-size-label")[0];
            if (paginatorLabel) {
                paginatorLabel.innerHTML = this.translate.instant("paginator.items_per_page");
            }
            this.spinner.hide();
        }, error => {
            this.functionsService.errorHandler(error["status"]);
            this.spinner.hide();
        });
    }

    changeStatus(f){
        f.value.status = 1;
    }

    notificationSave(f){
        document.getElementById('dpErr').innerText = "";
        this.addNotificationForm.value["message"] = this.addNotificationForm.value["message"]?this.addNotificationForm.value["message"].trim():"";
        //var dpScheduleInput = (<HTMLInputElement>document.getElementById('dpSchedule_input')).value;
        const schedule = <HTMLInputElement>document.querySelector('input[name=schedule]:checked');
        
        if(schedule.value == "1"){
            //Format date and time and add to variable
            var sd = this.functionsService.formatNotiDate(this.addNotificationForm.value["scheduleDate"]);
            var time = (<HTMLInputElement>document.getElementById("hour")).value;
            var datetime = new Date(sd+"T"+time);
            this.notification.scheduled = datetime;
            if(this.deviceService.browser == "Safari" && parseFloat(this.deviceService.browser_version) < 14){
                var timeOffset = new Date().getTimezoneOffset();       
                var d = new Date((datetime).getTime() + (timeOffset*60*1000));  
                this.notification.scheduled = new Date(d);
            }
        }else{
            this.notification.scheduled = null;
        }
        if (!this.addNotificationForm.valid || this.selectedGroups.length==0 || (schedule.value == "1" && (!this.addNotificationForm.value["scheduleDate"] || (this.notification.scheduled<=this.currentDate)))) {
            if(this.selectedGroups.length==0)
            {   
                this.userGroupErr();
            }
            if(schedule.value == "1" && !this.addNotificationForm.value["scheduleDate"]){
                document.getElementById('dpErr').innerText = this.translate.instant('general.required_field');
                this.translate.onLangChange.subscribe(() => {
                    document.getElementById('dpErr').innerText = this.translate.instant('general.required_field');
                });
            }
            else if(schedule.value == "1" && (this.notification.scheduled<=this.currentDate)){
                document.getElementById('dpErr').innerText = this.translate.instant('general.invalid_datetime');
                this.translate.onLangChange.subscribe(() => {
                    if(document.getElementById('dpErr')){
                        document.getElementById('dpErr').innerText = this.translate.instant('general.invalid_datetime');
                    }
                });
            }
            this.formSubmitted = true;
            return;
        } 
        f.value.message = (f.value.message).trim();
        //Save notification
        this.notification.message = f.value.message;
        var name = "";
        this.notification.tagId = "";
        this.notification.tagName = "";
        
        this.selectedGroups.forEach(element => {
            name = element['tagId'].split('&');
            this.notification.tagId = this.notification.tagId+name[0]+",";
            if(name.length>1){
                this.notification.tagName = this.notification.tagName+name[1]+",";
            }else{
                name = element['tagId'].split('#');
                this.notification.tagName = this.notification.tagName+name[0]+",";
            }
        });
        this.notification.tagId = this.notification.tagId.slice(0, -1); 
        this.notification.tagName = this.notification.tagName.slice(0, -1); 
    
        f.value.userGroup = this.notification.tagId;
        f.value.groupName = this.notification.tagName;
        
        if(this.selectedGroups.length==this.groupList.length){
            this.notification.tagId = "All";
            this.notification.tagName = "All";
        } 
        
        this.notification.status = f.value.status?Number(f.value.status):0;
        this.notification.pushNotification = this.selectedOptions[0];
        this.notification.emailNotification = this.selectedOptions[1];
        this.notification.sms = this.selectedOptions[2];
        this.notification.voiceCall = this.selectedOptions[3];

        this.spinner.show();
        this.apiService.saveNotification(this.notification).subscribe(
            async data => {
                this.formSubmitted = false;
                f.value.id = data["content"];
                this.notification.id = f.value.id;
                if(f.value.id > 0){
                    if(f.value.status==1 || this.notification.scheduled){
                        f.value.status = 0;
                        f.value.tagId = f.value.userGroup;
                        this.notification.createdBy = Number(await this.functionsService.getUserId());
                        this.sendNotificationPrompt(this.notification);
                    } else {
                        this.fetchNotifications();
                        this.spinner.hide();
                    }
                    this.toggleShowAddNotificationForm();
                }else {this.spinner.hide();}
                
            }, error => {
                this.spinner.hide();
                this.functionsService.errorHandler(error["status"]);
            }
        )
    }

    private minSelectedCheckboxes(min = 1) {
        const validator: ValidatorFn = (formArray: UntypedFormArray) => {
          var totalSelected = formArray.controls
            .map(control => control.value)
            .reduce((prev, next) => next ? prev + next : prev, 0);

            this.selectedOptions = formArray.controls.map(control => control.value)
            if(document.getElementById('optionsErr')){
                if(!(totalSelected >= min)){
                    document.getElementById('optionsErr').innerText = this.translate.instant('notification.one_option_err');
                    this.translate.onLangChange.subscribe(() => {
                        totalSelected = formArray.controls
                        .map(control => control.value)
                        .reduce((prev, next) => next ? prev + next : prev, 0);
                        if(document.getElementById('optionsErr') && totalSelected==0){
                            document.getElementById('optionsErr').innerText = this.translate.instant('notification.one_option_err');
                        }
                    });
                }else{
                    document.getElementById('optionsErr').innerText = "";
                }
            }
          // if the total is not greater than the minimum, return the error message
          return totalSelected >= min ? null : { required: true };
        };
      
        return validator;
    }

    getScheduleNoti(value){
        if(value==1){
            document.getElementById("save").hidden = true;
            document.getElementById("scheduled_yes").hidden = false;
            document.getElementById("schedule").hidden = false;
            document.getElementById("send").hidden = true;
        }else{
            document.getElementById("save").hidden = false;
            document.getElementById("scheduled_yes").hidden = true;
            document.getElementById("schedule").hidden = true;
            document.getElementById("send").hidden = false;
            document.getElementById('dpErr').innerText = "";
        }
    }

    editNotification(id){
        this.apiService.getNotification(id).subscribe(
            data => {
            this.showAddNotificationForm = true;
            this.toggleShowAddNotificationForm();
            this.openEditNotificationModal(data);
            },
            error => {
                this.functionsService.errorHandler(error["status"]);
            }
        );
    }

    sendNotificationPrompt(notification){
        if(!notification.tagName){
            this.spinner.hide();
            const okModalRef = this.modalService.open(OkModalComponent);
            okModalRef.componentInstance.title = this.translate.instant('notification.invalid_group');
            okModalRef.componentInstance.message = this.translate.instant('notification.select_valid_group');
            return;
        }

        if(notification.scheduled){
            if((notification.scheduled)<=(this.currentDate)){
                this.spinner.hide();
                const okModalRef = this.modalService.open(OkModalComponent);
                okModalRef.componentInstance.title = "Error";
                okModalRef.componentInstance.message = this.translate.instant('general.invalid_datetime');
                return;
            }
        }

        this.apiService.approveNotificationsStatus().subscribe(
            data => {
                const confirmModalRef = this.modalService.open(ConfirmationModalComponent);
                this.spinner.hide();
                if(data["approve"]){
                    if(notification.scheduled){ 
                        confirmModalRef.componentInstance.title = this.translate.instant('notification.schedule_notification');
                        confirmModalRef.componentInstance.message = this.translate.instant('notification.send_schedule_prompt') + `"${notification.message}"` + this.translate.instant('notification.to_send_to') + this.functionsService.formatMultiGroupName(notification.tagName)+"? <br>"+ this.translate.instant('notification.sent_once_approved_scheduling');
                    }
                    else{
                        confirmModalRef.componentInstance.title = this.translate.instant('notification.send_notification');
                        confirmModalRef.componentInstance.message = this.translate.instant('notification.send_not_prompt') + `"${notification.message}"` + this.translate.instant('general.to') + this.functionsService.formatMultiGroupName(notification.tagName)+"? <br>"+ this.translate.instant('notification.sent_once_approved');
                    }
                    
                    confirmModalRef.result.then(
                        confirmed => {
                            if(confirmed){
                                this.spinner.show();
                                notification.status = 2;
                                this.apiService.updateSentStatus(notification).subscribe(
                                    () => {
                                        this.fetchNotifications();
                                        this.spinner.hide();
                                    },
                                    error => {
                                        this.fetchNotifications();
                                        this.spinner.hide();
                                        this.functionsService.errorHandler(error["status"]);
                                    }
                                );
                            }
                            else{
                                this.fetchNotifications();
                            }
                        }
                    );
                }
                else{
                    if(notification.scheduled){ 
                        confirmModalRef.componentInstance.title = this.translate.instant('notification.schedule_notification');
                        confirmModalRef.componentInstance.message = this.translate.instant('notification.send_schedule_prompt') + `"${notification.message}"` + this.translate.instant('notification.to_send_to') + this.functionsService.formatMultiGroupName(notification.tagName)+"?";
                        confirmModalRef.result.then(confirmed => {
                            if (confirmed) {
                                notification.status = 3;
                                this.spinner.show();
                                this.apiService.updateSentStatus(notification).subscribe(
                                    () => {
                                        this.spinner.hide();
                                        this.fetchNotifications();
                                    },
                                    error => {
                                        this.spinner.hide();
                                        this.functionsService.errorHandler(error["status"]);
                                    }
                                );
                            }
                            else{
                                this.fetchNotifications();
                            }
                        });
                    }
                    else {
                        confirmModalRef.componentInstance.title = this.translate.instant('notification.send_notification');
                        confirmModalRef.componentInstance.message = this.translate.instant('notification.send_not_prompt') + `"${notification.message}" ${this.translate.instant('general.to')} ${this.functionsService.formatMultiGroupName(notification.tagName)}?`;
                        confirmModalRef.result.then(confirmed => {
                            if (confirmed) {
                                if(notification.tagName=="All"){
                                    notification.tagId = "";
                                    var name ="";
                                    this.groupList.forEach(element => {
                                        name = element['tagId'].split('&');
                                        notification.tagId = notification.tagId+name[0]+",";
                                    });
                                    notification.tagId = notification.tagId.slice(0, -1); 
                                }
                                this.sendNotification(notification);
                            }
                            else{
                                this.fetchNotifications();
                            }
                        });
                    }
                }
            }
        );
    }

    sendNotification(notification){
        this.spinner.show();
        //Send notification to all users
        var groupArray = notification.tagId.split(',');
        var content = {
            "ContentIos":"{\"aps\":{\"alert\":{\"title\": \"Contigo MSJ\",\"body\": \""+ notification.message +"\"},\"sound\":\"default\",\"category\": \"Alert\",\"content-available\": 1,\"mutable-content\": 1}}",
            // "ContentAndroid":"{\"data\":{\"message\":\"" + notification.message +"\"}}",
            "ContentAndroid":"{\"message\":{\"android\":{\"data\":{\"message\":\"" +  notification.message + "\"}}}}",
            "TagInput": groupArray,
            "NotificationId": notification.id,
            "Message": notification.message,
            "PushNotification":notification.pushNotification,
            "EmailNotification":notification.emailNotification,
            "SMS":notification.sms,
            "VoiceCall":notification.voiceCall
        };
      
        this.apiService.sendNotificationOptions(content).subscribe(
            () => {
                this.fetchNotifications();
                this.spinner.hide();
            },
            error => {
                this.spinner.hide();
                this.functionsService.errorHandler(error["status"]);
            }
        );
    }

    cancelNotification(notification){
        const confirmModalRef = this.modalService.open(ConfirmationModalComponent);
        confirmModalRef.componentInstance.title = this.translate.instant('notification.cancel_send');
        confirmModalRef.componentInstance.message = this.translate.instant('notification.cancel_send_prompt')+`"${notification.message}" ${this.translate.instant('general.to')} ${this.functionsService.formatMultiGroupName(notification.tagName)}?`;
        confirmModalRef.result.then(confirmed => {
            if (confirmed) {
                this.spinner.show();
                this.apiService.cancelNotification(notification).subscribe(
                    () => {
                        this.fetchNotifications();
                        this.spinner.hide();
                    },
                    error => {
                        this.spinner.hide();
                        this.functionsService.errorHandler(error["status"]);
                    }
                );
            }
        });
    }

    deleteNotification(notification){
        const confirmModalRef = this.modalService.open(ConfirmationModalComponent);
        confirmModalRef.componentInstance.title = this.translate.instant('notification.delete_notification');
        confirmModalRef.componentInstance.message = this.translate.instant('notification.delete_not_prompt')+`"${notification.message}"?`;
        confirmModalRef.result.then(confirmed => {
            if (confirmed) {
                this.spinner.show();
                this.apiService.deleteNotification(notification).subscribe(
                    () => {
                        this.fetchNotifications();
                        this.spinner.hide();
                    },
                    error => {
                        this.spinner.hide();
                        this.functionsService.errorHandler(error["status"]);
                    }
                );
            }
        });
    }

    private openEditNotificationModal(notification) {
        const modalRef = this.modalService.open(EditNotificationComponent, { size: 'lg' });
        modalRef.componentInstance.notiToUpdate = notification;
        modalRef.result.then(() => this.fetchNotifications());
    }

    nextPage(evt){
        this.pageIndex = evt.pageIndex;
        this.pageSize = evt.pageSize;
        this.fetchNotifications();
    }

    sortData(evt){
        this.active = evt.active;
        this.direction = evt.direction;
        this.fetchNotifications();
    }

    applyFilter(){
        this.filterDate = this.filterNotiForm.value["filterDate"]?this.functionsService.formatDate({value:this.filterNotiForm.value["filterDate"]}):"";
        if((<HTMLInputElement>document.getElementById('filter')).value.trim() !=""){
            this.filter = (<HTMLInputElement>document.getElementById('filter')).value
            this.filter = this.filter.trim().toLowerCase();
        }

        if((this.filter!="") || (this.filterDate!="")){
            this.filterApplied = true;
            this.fetchNotifications();
        }
    }

    clearFilter(){
        this.filter = "";
        this.filterDate = "";
        this.filterNotiForm.reset();
        if((<HTMLInputElement>document.getElementById('datepicker_input'))){
            (<HTMLInputElement>document.getElementById('datepicker')).value = "";
            (<HTMLInputElement>document.getElementById('datepicker_input')).value = "";
        }
        if((<HTMLInputElement>document.getElementById('filter'))){
            (<HTMLInputElement>document.getElementById('filter')).value = "";
        }
        
        if(this.filterApplied){
            this.filterApplied = false;
            this.fetchNotifications();
        }
    }

    emptyInput(){
        if((<HTMLInputElement>document.getElementById("filter")).value == ""){
            this.filter = "";
            this.fetchNotifications();
        }
    }

    onItemSelect(item: any) {
        this.selectedGroups.push();
        this.userGroupValid();
    }

    onSelectAll(items: any) {
        this.selectedGroups = [];
        items.forEach(element => {
            this.selectedGroups.push(element);
        });
        this.userGroupValid();
    }

    onItemDeSelect(item: any) {
        const index: number = this.selectedGroups.indexOf(item);
        if (index !== -1) {
            this.selectedGroups.splice(index, 1);
        }   
        if(this.selectedGroups.length==0){
            this.userGroupErr();
        }
    }

    onDeSelectAll(items: any) {
        this.selectedGroups = [];
        this.userGroupErr();
    }

    userGroupValid(){
        let elements = document.getElementsByClassName("dropdown-btn");
        let display = elements.item(0) as HTMLElement;
        display.style.border = "1px solid #28a745";
        document.getElementById('userGroupErr').innerText = "";
    }

    userGroupErr(){
        let elements = document.getElementsByClassName("dropdown-btn");
        let display = elements.item(0) as HTMLElement;
        display.style.border = "1px solid #dc3545";
        document.getElementById('userGroupErr').innerText = this.translate.instant('general.required_field');
        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            document.getElementById('userGroupErr').innerText = this.translate.instant('general.required_field');
        });
    }

    get message() { return this.controlGetter('message'); }
    get options() { return this.controlGetter('options'); }
    get schedule() { return this.controlGetter('schedule'); }
    
    controlGetter(controlName) {
      const control =  this.addNotificationForm.get(controlName);
      return control && (control.touched || this.formSubmitted) ? control : {};
    }

    @HostListener('window:resize', [])
    getScreenSize() {
        this.scrHeight = window.innerHeight;
        this.scrWidth = window.innerWidth;
        this.displayedColumns = ['message', 'userGroup', 'created', 'sentDate', 'status', 'scheduled', 'actions'];
        
        if(this.scrWidth <= 375){
            this.displayedColumns = ['userGroup', 'created', 'actions'];
        }
        else if(this.scrWidth <= 440){
            this.displayedColumns = ['userGroup', 'created', 'status', 'actions'];
        }
        else if(this.scrWidth <= 600){
            this.displayedColumns = ['userGroup', 'created', 'sentDate', 'status', 'actions'];
        }
    }
}